import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import {
  generateCallReportNew,
  downloadCallReportByFilename,
  downloadExcelReport,
  downloadExcelReportByFilename,
} from "../../api";

export const ReportsPage = () => {
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [clinicId, setClinicId] = useState("");
  const [adminIds, setAdminIds] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [reportResult, setReportResult] = useState(null);

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const clientId = queryParams.get("client_id") || localStorage.getItem("clientId") || "";

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setReportResult(null);

    try {
      // Передаем необработанные данные в API-функцию.
      // Вся логика форматирования теперь находится в api.js.
      const reportData = {
        start_date: startDate,
        end_date: endDate,
        clinic_id: clinicId || clientId,
      };


      const response = await generateCallReportNew(reportData);

      // Обработка успешного ответа
      if (response.status === "success" || response.message) {
        console.log("Ответ от сервера:", response);

        // Получаем полный путь к файлу из ответа
        const fullPath = response.filename;
        console.log("Полный путь к файлу:", fullPath);

        // Извлекаем только имя файла из полного пути
        let fileName = fullPath;
        if (fullPath && fullPath.includes("/")) {
          fileName = fullPath.split("/").pop();
        }
        console.log("Извлеченное имя файла:", fileName);

        // Формируем результат для отображения
        const reportData = {
          filename: fileName,
          fullPath: fullPath,
          createdAt: new Date().toLocaleString(),
          startDate: startDate,
          endDate: endDate,
          reportType: "full",
          clinicId: clinicId || clientId || "Все клиники",
        };

        console.log("Сформированные данные отчёта:", reportData);
        setReportResult(reportData);
      } else {
        throw new Error("Не удалось сгенерировать отчёт");
      }
    } catch (err) {
      console.error("Error generating report:", err);
      setError(err.message || "Произошла ошибка при генерации отчёта");
    } finally {
      setLoading(false);
    }
  };

  const handleDownloadReport = () => {
    if (!reportResult) {
      console.error("Нет данных о результате отчёта");
      return;
    }

    console.log("Данные отчёта:", reportResult);

    if (!reportResult.filename && !reportResult.fileBaseName) {
      setError("Имя файла отчёта не найдено");
      return;
    }

    // Используем fileBaseName, если оно есть, иначе filename
    const fileName = reportResult.fileBaseName || reportResult.filename;
    console.log("Имя файла для скачивания:", fileName);

    // Открываем URL для скачивания отчёта, используя только имя файла без пути
    const fileUrl = downloadCallReportByFilename(fileName);
    console.log("URL для скачивания:", fileUrl);
    window.open(fileUrl, "_blank");
  };

  return (
    <div className="py-6">
      {/* Заголовок страницы */}
      <div className="text-center mb-10">
        <h1 className="text-4xl font-bold mb-4">
          Генерация <span className="gradient-text">отчётов</span>
        </h1>
        <p className="text-gray-500 text-xl max-w-2xl mx-auto">
          Выберите период и клинику для создания детализированного отчёта.
        </p>
      </div>

      {/* Форма ввода данных */}
      <div className="max-w-4xl mx-auto bg-white p-8 rounded-lg shadow-lg border border-gray-200 mb-8">
        <form onSubmit={handleSubmit}>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
            {/* Поле ввода начальной даты */}
            <div>
              <label htmlFor="startDate" className="block text-sm font-medium text-gray-600 mb-2">
                Дата начала <span className="text-red-500">*</span>
              </label>
              <input
                id="startDate"
                type="date"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
                required
                className="w-full bg-white border border-gray-200 rounded-md p-2.5 text-gray-800 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-purple-500 transition-colors"
              />
            </div>

            {/* Поле ввода конечной даты */}
            <div>
              <label htmlFor="endDate" className="block text-sm font-medium text-gray-600 mb-2">
                Дата окончания <span className="text-red-500">*</span>
              </label>
              <input
                id="endDate"
                type="date"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
                required
                className="w-full bg-white border border-gray-200 rounded-md p-2.5 text-gray-800 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-purple-500 transition-colors"
              />
            </div>

            {/* Поле ввода ID клиента */}
            <div>
              <label htmlFor="clinicId" className="block text-sm font-medium text-gray-600 mb-2">
                ID Клиники
                <span className="text-gray-500 text-xs ml-1">(необязательно)</span>
              </label>
              <input
                id="clinicId"
                type="text"
                value={clinicId}
                onChange={(e) => setClinicId(e.target.value)}
                placeholder={clientId || "ID клиники"}
                className="w-full bg-white border border-gray-200 rounded-md p-2.5 text-gray-800 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-purple-500 transition-colors"
              />
            </div>

            {/* Поле ввода ID администраторов */}
            <div>
              <label htmlFor="adminIds" className="block text-sm font-medium text-gray-600 mb-2">
                ID Администраторов
                <span className="text-gray-500 text-xs ml-1">(через запятую)</span>
              </label>
              <input
                id="adminIds"
                type="text"
                value={adminIds}
                onChange={(e) => setAdminIds(e.target.value)}
                placeholder="ID администраторов"
                className="w-full bg-white border border-gray-200 rounded-md p-2.5 text-gray-800 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-purple-500 transition-colors"
              />
            </div>
          </div>

          {/* Кнопка отправки формы */}
          <div className="mt-8 text-center">
            <button
              type="submit"
              disabled={loading}
              className="gradient-button text-gray-800 font-medium py-3 px-8 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-200 w-full md:w-auto"
            >
              {loading ? (
                <span className="flex items-center justify-center">
                  <svg className="animate-spin -ml-1 mr-2 h-5 w-5 text-gray-800" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                  Обработка...
                </span>
              ) : (
                'Сгенерировать отчёт'
              )}
            </button>
          </div>
        </form>
      </div>

      {/* Блок с ошибкой */}
      {error && (
        <div className="max-w-4xl mx-auto p-4 mb-8 bg-red-100 text-gray-800 rounded-lg border border-red-200">
          <h3 className="font-bold text-lg mb-2">Ошибка</h3>
          <p>{error}</p>
        </div>
      )}

      {/* Блок с результатами отчёта */}
      {reportResult && (
        <div className="max-w-4xl mx-auto bg-white p-8 rounded-lg shadow-lg border border-gray-200">
          <h2 className="text-2xl font-bold text-gray-800 mb-6">
            Отчёт успешно сгенерирован
          </h2>
          
          <div className="bg-gray-100 rounded-lg p-6 mb-6 border border-gray-600">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <p className="text-gray-500 text-sm font-medium mb-1">Имя файла:</p>
                <p className="text-gray-800 break-all">{reportResult.filename}</p>
              </div>
              <div>
                <p className="text-gray-500 text-sm font-medium mb-1">Период:</p>
                <p className="text-gray-800">
                  {reportResult.startDate} — {reportResult.endDate}
                </p>
              </div>
              <div>
                <p className="text-gray-500 text-sm font-medium mb-1">Дата создания:</p>
                <p className="text-gray-800">{reportResult.createdAt}</p>
              </div>
              <div>
                <p className="text-gray-500 text-sm font-medium mb-1">Клиника:</p>
                <p className="text-gray-800">{reportResult.clinicId}</p>
              </div>
            </div>
          </div>

          <div className="flex flex-wrap gap-4">
            <button
              onClick={handleDownloadReport}
              disabled={loading}
              className="flex items-center px-6 py-2.5 bg-gradient-to-r from-red-500 to-red-700 hover:from-red-600 hover:to-red-800 text-gray-800 font-medium rounded-md transition-all duration-200"
            >
              <svg
                className="h-5 w-5 mr-2"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  d="M6 2a2 2 0 00-2 2v12a2 2 0 002 2h8a2 2 0 002-2V7.414A2 2 0 0015.414 6L12 2.586A2 2 0 0010.586 2H6zm5 6a1 1 0 10-2 0v3.586l-1.293-1.293a1 1 0 10-1.414 1.414l3 3a1 1 0 001.414 0l3-3a1 1 0 00-1.414-1.414L11 11.586V8z"
                  clipRule="evenodd"
                />
              </svg>
              Скачать PDF
            </button>

            <button
              onClick={async () => {
                try {
                  setLoading(true);
                  const filename = await downloadExcelReport(
                    reportResult.startDate,
                    reportResult.endDate,
                    reportResult.clinicId !== "Все клиники"
                      ? reportResult.clinicId
                      : ""
                  );
                  const excelUrl = downloadExcelReportByFilename(filename);
                  window.open(excelUrl, "_blank");
                } catch (error) {
                  console.error("Ошибка при скачивании Excel-отчёта:", error);
                  setError(error.message || "Произошла ошибка при скачивании Excel-отчёта");
                } finally {
                  setLoading(false);
                }
              }}
              disabled={loading}
              className="flex items-center px-6 py-2.5 bg-gradient-to-r from-green-500 to-green-700 hover:from-green-600 hover:to-green-800 text-gray-800 font-medium rounded-md transition-all duration-200"
            >
              <svg
                className="h-5 w-5 mr-2"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  d="M6 2a2 2 0 00-2 2v12a2 2 0 002 2h8a2 2 0 002-2V7.414A2 2 0 0015.414 6L12 2.586A2 2 0 0010.586 2H6zm2 10a1 1 0 011-1h2a1 1 0 110 2H9a1 1 0 01-1-1zm4-4a1 1 0 00-1-1H9a1 1 0 000 2h2a1 1 0 001-1z"
                  clipRule="evenodd"
                />
              </svg>
              {loading ? 'Загрузка...' : 'Скачать Excel'}
            </button>
          </div>
        </div>
      )}
    </div>
  );
};
